module.exports = __webpack_public_path__ + "static/forelli2-9402d7f7d068ccea8996a408e4c95b92.png";